import { useEffect, useState } from 'react';

export const useShowNotifications = () => {
  const [showBell, setShowBell] = useState(false);

  useEffect(() => {
    if (location.pathname.indexOf('detail') >= 0) {
      setShowBell(false);
    } else {
      setShowBell(true);
    }
  }, [location]);

  return {
    showBell,
  };
};
